// extracted by mini-css-extract-plugin
export default {"journeyButton":"StartMyJourney_journeyButton__nSsWp"};